module.exports = __webpack_public_path__ + "assets/img/banlie.9bf4717c.png";